import React, {useMemo} from 'react';
import style from './style.module.scss';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {SimpleRating} from './SimpleRating';
import {ExpertRating} from './ExpertRating';

type TRatingsProps = Pick<IProductSnippet, 'ratings' | 'reviewsCount' | 'reviewsUrl'> &
    Pick<IProductSnippet['analytics'], 'onReviewsClick'>;

const RATINGS_TO_DISPLAY = ['VIVINO', 'REVIEWS'];

export const Ratings = (props: TRatingsProps) => {
    const {ratings, reviewsUrl, reviewsCount, onReviewsClick} = props;

    const ratingsList = useMemo(() => {
        return ratings
            .filter((rating) => RATINGS_TO_DISPLAY.includes(rating.code))
            .map(({code, value, title}) => {
                if ('REVIEWS' === code) {
                    return (
                        <SimpleRating
                            key={code}
                            value={value}
                            reviewsCount={reviewsCount}
                            reviewsUrl={reviewsUrl}
                            onClick={onReviewsClick}
                        />
                    );
                }
                return <ExpertRating key={code} value={value} code={code} title={title} />;
            });
    }, [onReviewsClick, ratings, reviewsCount, reviewsUrl]);

    return <div className={style.main}>{ratingsList}</div>;
};
